<template>
    <div class="page1">

        <div class="snowflake-sum">
            <div class="snowflake" :key="index" v-for="index in 50"></div>
        </div>

        <!-- <Header/> -->
        <div>

            <div class="page-header">
                <div class="container">
                    <div class="page-header__logo text-center pt-4 pb-3">
                        <img src="./assets/images/easy-ielts-logo.png" class="mw-100" alt="">
                    </div>
                    <div class="page-headline text-center">
                        <img src="./assets/images/title.png" class="mw-100" alt="">
                    </div>
                </div>
            </div>

            <div class="page-middle mt-5">
                <div class="container">
                    <div class="intro-teacher">
                        <span>Trải nghiệm bài thi kiểm tra năng lực tiếng Anh chuẩn xác nhất được thiết kế bởi đội ngũ thầy cô, chuyên gia trong và ngoài nước.</span>
                        <div class="intro-teacher__image">
                            <img src="./assets/images/teacher.png" alt="">
                            <div class="gift gift-1">
                                <img src="./assets/images/gift1.png" alt="">
                            </div>
                            <div class="gift gift-2">
                                <img src="./assets/images/gift2.png" alt="">
                            </div>
                            <div class="gift gift-3">
                                <img src="./assets/images/gift3.png" alt="">
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div style="padding-bottom:150px">
                
                <ContactForm
                v-model="form"
                :step="form.step"
                @change-step="ChangeStep"
                />

                <!-- error message -->
                <div v-if="error.msg">
                    <div class="container">
                        <div class="text-center">
                            <p class="text-danger h4 bold">{{ error.msg }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- error message end -->

            <div class="page-footer mt-5">
                <div class="satanx">
                    <img class="mw-100" src="./assets/images/satan.png" alt="">
                </div>
                <img class="mw-100" src="./assets/images/bg-footer.png" alt="">
            </div>
        </div>
        
    </div>
</template>
<script>


import ContactForm from '@/components/ContactForm.vue'

// mixins import
import Page1 from '@/plugins/TestPlugin/mixins/page1'

export default {
    mixins: [Page1],
    created() {
    },
    components: {
        ContactForm
    },
    data() {
        return {
            form: {
                examchoose: [],
                examchoose2: [],
                email: '',
                name: '',
                age: '',
                phone: '',
                confirmPhone: '',
                step: 1, // Step 0. chọn đăng nhập tài khoản
                level: 2,
                class: '',
                school: ''
            },
            show: true,
            nextButtonPress: false,
            startButtonPress: false,
            reInputPhone: false,
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    beforeUpdate() {
    },
    destroyed() {
    },
    updated() {
    }

}
</script>

<style lang="scss">

.page1 {


    .form-info.xmas .form-group > div {
        
        box-shadow: 0px 3px 3px 1px #000000;
        border-radius: 22px;
        border: 5px solid #185e30;
        position: relative;
        background-color: #fff;

        &::before {
            content: '';
            display: block;
            width: 120px;
            height: 60px;
            background-image: url(./assets/images/snow-input.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -20px;
            left: -20px;
        }

        &::after {
            content: '';
            display: block;
            width: 60px;
            height: 60px;
            background-image: url(./assets/images/stan-hat.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -30px;
            right: -22px;
        }
    }
}


</style>

<style lang="scss" scoped>

$screen1366: 1366px;
$screen1144: 1200px;
$table: 992px;
$mobileSm: 768px;

@mixin sc1366 {
    @media (max-width: #{$screen1366}) {
        @content;
    }
}

@mixin sc1144 {
    @media (max-width: #{$screen1144}) {
        @content;
    }
}

@mixin mobile {
    @media (max-width: #{$screen1144}) {
        @content;
    }
}

@mixin table {
    @media (max-width: #{$table}) {
        @content;
    }
}

@mixin mobileSm {
    @media (max-width: #{$mobileSm}) {
        @content;
    }
}

@media (max-width: 500px) {
    .page1 .page-header__logo::before {
        content: none !important;
    }
    .page1 .page-header__logo::after {
        content: none !important;
    }

    .intro-teacher {
        width: 95% !important;
    }
}



.snowflake {
  --size: 1vw;
  width: var(--size);
  height: var(--size);
  background: white;
  border-radius: 50%;
  position: absolute;
  top: -5vh;
}

@keyframes snowfall {
  0% {
    transform: translate3d(var(--left-ini), 0, 0);
  }
  100% {
    transform: translate3d(var(--left-end), 102vh, 0);
  }
}

@for $i from 1 through 50 {
  .snowflake:nth-child(#{$i}) {
    --size: #{random(5) * 0.2}vw;
    --left-ini: #{random(20) - 10}vw;
    --left-end: #{random(20) - 10}vw;
    left: #{random(100)}vw;
    animation: snowfall #{5 + random(30)}s linear infinite;
    animation-delay: -#{random(30)}s;
  }
}

/* added small blur every 6 snowflakes*/
.snowflake:nth-child(6n) {
  filter: blur(1px);
}

.page1 {
    background-image: url(./assets/images/bg.png);
    min-height: 100vh !important;
    background-size: cover;
    background-position: bottom center;
    // height: 100vh !important;
    background-attachment: fixed;


    .page-header__logo {

        position: relative;

        
        &::after {
            content: '';
            display: block;
            background-image: url(./assets/images/led-left.png);
            background-repeat: no-repeat;
            background-size: contain;
            width: 700px;
            height: 200px;
            position: absolute;
            left: -25%;
            top: 0;

            @include sc1144() {
                left: -20%;
                width: 500px;
            }

            @include table() {
                left: -40%;
            }

            @include mobileSm() {
                left: -60%;
            }
            
        }

        &::before {
            content: '';
            display: block;
            background-image: url(./assets/images/led-right.png);
            background-repeat: no-repeat;
            background-size: contain;
            width: 700px;
            height: 200px;
            position: absolute;
            right: -25%;
            top: 0;


            @include sc1144() {
                width: 500px;
            }

            @include table() {
                right: -40%;
            }

            @include mobileSm() {
                right: -70%;
            }
        }
    }
}

.page-header {
    position: relative;
}

.page-footer {

    position: absolute;
    bottom: 0;

    margin-top: 100px !important;

    .satanx {
        position: absolute;
        bottom: 20px;
        max-width: 450px;

        @include sc1366 {
            width: 400px;
        }

        @include sc1144 {
            width: 300px;
        }

        @include mobile() {
            display: none;
        }
    }
}

.page-middle {

    background: rgb(2,0,36);
    background: linear-gradient(90deg, rgba(2,0,36,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 74%, rgba(255,255,255,0) 74%);

    @include sc1144 {
        background: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, white 50%, white 84%, rgba(255, 255, 255, 0) 83%);
    }

    @include mobile() {
        background: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, white 50%, rgba(2, 0, 36, 0) 100%);
    }

    .intro-teacher {
        
        padding: 10px;
        
        position: relative;
        width: 45%;
        max-width: 450px;
        text-align: center;
        margin: auto;

        @include sc1144() {
            width: 70%;
        }
        
        span {
            color: #185e30;
            font-size: 1.2rem;
            font-weight: 700;
                
            display: block;            
        }

        
        .intro-teacher__image {
            position: absolute;
            top: -56px;
            right: -450px;
            width: 400px;

            @include sc1366 {
                top: -50px;
                right: -370px;
                width: 360px;
            }

            @include mobile() {
                display: none;
            }

            .gift {
                position: absolute;
                width: 60px;
                transform: translateX(-50%);
            }

            .gift-2 {
                left: 20%;
                bottom: -100px;
                animation: ring 3.8s .7s ease-in-out infinite;
                transform-origin: 50% 4px;

                @include sc1366() {
                    bottom: -66px;
                    width: 40px;
                }
            }

            .gift-1 {
                left: 40%;
                bottom: -70px;
                animation: ring 4s .7s ease-in-out infinite;
                transform-origin: 50% 4px;

                @include sc1366() {
                    bottom: -46px;
                    width: 40px;
                }
            }

            .gift-3 {
                left: 60%;
                bottom: -100px;
                animation: ring 3.9s .7s ease-in-out infinite;
                transform-origin: 50% 4px;

                @include sc1366() {
                    bottom: -66px;
                    width: 40px;
                }
            }
        }

    }
}

@keyframes ring {
    0% { -webkit-transform: rotateZ(-10deg); }
    50% { -webkit-transform: rotateZ(10deg); }
    100% { -webkit-transform: rotateZ(-10deg); }
}

.invalid-feedback {
    color: #ffc0c6;
}

.form-info {

    .form-group {

        margin-bottom: 20px;
        margin-top: 36px;

        div {

            input {
                border: none;
                margin: 0;
                box-shadow: none;
                z-index: 999;
                position: relative;
                background-color: transparent;               
            }
        }
    }

}

.title-form {
    
    h5{
        text-align: center;
        color: #fff;
        font-weight: 500;
        font-size: 1rem;
    }
}


</style>

<style scoped>

.form-info{
    width: 45%;
    max-width: 450px;
    margin: auto;
}
.form-control {
    border-radius: 15px;
    color: #0158a8;
    line-height: 1.5;
    margin-bottom: 20px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    height: 50px;
    padding: 15px;
}
.form-control::-webkit-input-placeholder {
    color: #0158a8;
}
.input-group-5{
    display: flex;
    align-items: center;
    border-radius: 15px;
    color: #0158a8;
    margin-bottom: 18px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;height: 50px;
    padding: 15px;
    appearance: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-control-input {
    top: 10px;
}
.checkbox {
    display:flex;
    flex-direction:column;
    align-items: center;
    margin-left: 40px;
}

@media only screen and (max-width: 1200px){
    .form-info {
        width: 50%;
    }
}

@media only screen and (max-width: 992px){
    .form-info {
        width: 65%;
    }
}

@media only screen and (max-width: 768px){

    .form-info {
        width: 100%;
    }
    .learn-check {
        margin: 0 0px 0 10px;
    }
    .checkbox{
        margin-left: 10px;
    }
    .title-form h5 {
        font-size: 18px;
    }
    .input-group-5{
        height: auto;
        display: block;
        text-align: center;
        box-shadow: 0px 5px 10px #bac1c5;
        z-index: 9;
        position: relative;
    }
    .learn-check {
        padding-left: 0px;
        display: block;
        margin-bottom: 20px;
    }
    .input-group-5 .checkbox{
        display: inline-block !important;
    }
    .input-group-5 .checkbox:last-child{
        margin-left: 30px;
    }
    .cloudy-pg1{
        bottom: -160px;
    }
    .btn-custom.btn-success{
        font-size: 25px;
    }
}
@media only screen and (min-width: 1024px)  and (max-width: 1400px){
    .cloudy-pg1{
        bottom: -220px;
    }
}


@media (max-width: 680px){
    form.qanda {
        width: unset;
    }

    form.qanda .custom-radio {
        margin-top: 10px;
    }
}

</style>